import React, { useEffect, useState } from "react";
import { SettingsChangeDefaultBranchInfo } from "./widget/SettingsChangeDefaultBranchBody";
import { SettingsChangeDefaultBranchContextImport } from "../../../provider/settings/change_default_branch/SettingsChangeDefaultBranchContextProvider";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { DefaultBranch } from "../../../model/settings/SettingsChangeDefaultBranchModel";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";
import { useDispatch } from "react-redux";
import { applyChoosenDefaultBranch } from "../../../libraries/state_reducers/settings/SettingsChangeDefaultBranchReducer";

const SettingsChangeDefaultBranchContent = (props: { type?: number }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const dispatch = useDispatch();
  const branchDetailSelector = useSelector(
    (state: RootState) => state.settingsChangeDefaultBranch.branchDetail
  );

  const { getBranchDefaulInfo, branchDefaultInfo, setDefaultBranch } =
    SettingsChangeDefaultBranchContextImport();

  const [branchDefault, setBranchDefault] = useState<DefaultBranch | undefined>(
    undefined
  );

  useEffect(() => {
    getBranchDefaulInfo();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (branchDefaultInfo !== undefined) {
      setBranchDefault(branchDefaultInfo);
    }
  }, [branchDefaultInfo]);

  useEffect(() => {
    if (branchDetailSelector !== undefined) {
      setDefaultBranch(branchDetailSelector?.branch_id!);
      dispatch(applyChoosenDefaultBranch({ branchDetail: undefined }));
    }
    // eslint-disable-next-line
  }, [branchDetailSelector]);

  return (
    <SettingsChangeDefaultBranchInfo
      type={type}
      branchDefault={branchDefault}
    />
  );
};

export default SettingsChangeDefaultBranchContent;
